/* eslint-disable no-return-assign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	MinusCircleOutlined,
	PlusCircleOutlined,
	PlusOutlined,
	RetweetOutlined,
	RollbackOutlined,
} from '@ant-design/icons';

import { Upload, Modal, Button, message, Spin } from 'antd';
import cookie from 'browser-cookies';
import Cropper from 'cropperjs';
import { ImageViewer } from 'components';
import { isEmpty, debounce } from 'lodash';
import { cache } from 'utils';
import './index.less';

const defaultLocale = {
	limitPerSizeTips: '请上传不超过${sizeText}的图片',
	acceptTips: '仅支持JPG/JPEG/PNG格式的图片',
};

class UploadImage extends Component {
	constructor (props) {
		super(props);

		const locale = Object.assign({}, defaultLocale, this.props.locale);
		this.state = {
			previewVisible: false, // 是否预览图片
			previewImage: '', // 预览的图片
			cutVisible: false, // 裁剪图片
			spinning: false,
			locale,
		};
    this.debouncedErrorTips = debounce(this.errorTips, 500);
	}

	// 取消预览
	handleCancel = () => {
		this.setState({ previewVisible: false });
	}

	// 点击预览图片
	handlePreview = file => {
		let imageUrl;
		if (!isEmpty(file.response) && !isEmpty(file.response.response)) {
			imageUrl = file.response.response.url;
		}
		this.setState({
			previewImage: file.url || imageUrl || file.thumbUrl,
			previewVisible: true
		});
	}

	// 点击移除图片
	onRemove = (file) => {
		const { disabled, onRemove } = this.props;
		// disabled时，不可移除图片
		if (onRemove) {
			onRemove(file);
		}
		return !disabled;
	};

	getSizeUnitB (size) {
		const filesize = String(size);
		const upSize = parseInt(filesize, 10);
		if (filesize.endsWith('M')) {
			return upSize * 1024 * 1024;
		} else if (filesize.endsWith('K')) {
			return upSize * 1024;
		}
		return upSize;
	}

  errorTips = () => {
    message.error('图片上传超出限制，请重新选择');
  }

	// 上传之前的钩子
	beforeUpload = (file, fileList) => {
		const props = this.props;
		const limitPerSize = this.getSizeUnitB(props.limitPerSize);
		const { locale } = this.state;
		if (file.size > limitPerSize) {
			let text = '';
			if (limitPerSize >= 1024 * 1024) {
				text = Math.round(limitPerSize / 1024 / 1024) + 'MB';
			} else if (limitPerSize >= 1024) {
				text = Math.round(limitPerSize / 1024) + 'KB';
			} else {
				text = limitPerSize + 'B';
			}
			message.warning(locale.limitPerSizeTips.replace('${sizeText}', text));
			// message.warning(`请上传不超过${text}的图片`);
			return false;
		}
    if(fileList.length + props.fileList.length > props.limitCount){
      // message.error('图片上传超出限制，请重新选择');
      this.debouncedErrorTips();
      return false;
    }
		if (props.accept && file.type && props.accept.indexOf(file.type) === -1) {
			message.warning(locale.acceptTips);
			// message.warning('仅支持JPG/JPEG/PNG/SVG格式的图片');
			return false;
		}
		//文件格式为svg时，避免裁剪
		if (file.type === 'image/svg+xml') return true;
		if (props.cut) { // 图片需要裁剪
			this.setState({
				currentFile: file,
				cutVisible: true,
			});
			setTimeout(() => {
				// let img = document.getElementById('cut-image');
				const img = this.cutImage;
				img.src = URL.createObjectURL(file);
				img.addEventListener('ready', () => {
					const { cropper } = this.state;
					cropper && cropper.zoom && cropper.zoom(0);
				});
				var initRatio;
				const cropper = new Cropper(img, {
					aspectRatio: props.aspectRatio,
					autoCropArea: 1,
					zoom (event) {
						const ratio = event.detail.ratio;
						if (!initRatio) {
							initRatio = ratio;
						} else if (ratio < initRatio || ratio > initRatio * 1.1 ** 7) {
							event.preventDefault();
						}
					}
				});
				this.setState({
					viewMode: 3,
					cropper,
				});
			}, 200);
			return false;
		}
		return true;
	}

	onChange = ({ file, fileList }) => {
		// https://github.com/ant-design/ant-design/issues/15561#issuecomment-475108235
		// file.status is empty when beforeUpload return false
		this.props.onChange({ file, fileList: fileList.filter(file => !!file.status) });
	}

	handleUpload = file => {
		const contentServer = cache.get('contentServer');
		const defaultAction = `${contentServer}/upload/image?token=${cookie.get('token') || localStorage.getItem('loginToken')}`;
		const { action = defaultAction } = this.props;
		const formData = new FormData();
		formData.append('upload_file', file);
		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			xhr.open('POST', action, true);
			xhr.onreadystatechange = e => {
				if (xhr.readyState === 4) {
					resolve(xhr.response);
				}
			};
			xhr.timeout = e => { reject(new Error('请求超时')); };
			xhr.error = e => { reject(new Error('请求错误')); };
			xhr.abort = e => { reject(new Error('请求终止')); };
			xhr.responseType = 'json';
			xhr.send(formData);
		});
		/* return window.fetch(action, {
			body: formData,
			method: 'POST',
		}); */
	}

	// 裁剪图片
	confirmCutImg = () => {
		const { fillColor } = this.props;
		this.setState({ spinning: true });
		const { currentFile, cropper } = this.state;
		const type = currentFile.type || 'image/jpeg';
		const quality = currentFile.size > 1024 * 1024 ? 'low' : 'medium';

		cropper.getCroppedCanvas({ fillColor, imageSmoothingQuality: quality }).toBlob(blob => {
			const file = new Blob([blob], { type: type });
			this.handleUpload(file)
				.then(response => {
					file.url = response.response.url;
					file.uri = response.response.uri;
					file.response = response;
					file.status = 'done';
					file.uid = -Date.now();
					this.props.onChange({ file, fileList: [...this.props.fileList, file] });
					this.cancelCut();
				})
				.catch(err => message.error(err));
			// .then(response => response.text())
			// .then(JSON.parse)
		}, type);
	}

	// 取消裁剪
	cancelCut = () => {
		const { cropper } = this.state;
		// let image = document.getElementById('cut-image');
		const image = this.cutImage;
		const objURL = image.src;
		image.src = '';
		URL.revokeObjectURL(objURL);
		cropper.destroy();
		this.setState({
			cutVisible: false,
			spinning: false,
			currentFile: null,
			cropper: {}
		});
	}

	render () {
		const { props, state } = this;
		const { previewVisible, previewImage, cutVisible, cropper = {}, spinning } = state;
		const contentServer = cache.get('contentServer');
		const defaultAction = `${contentServer}/upload/image?token=${cookie.get('token') || localStorage.getItem('loginToken')}`;
		const { action = defaultAction, accept, fileList = [], uploadText, multiple, limitCount, onChange, ...rest } = props;
		const uploadButton = (
			<div>
				<PlusOutlined />
				<div className="ant-upload-text">{uploadText}</div>
			</div>
		);

		return (
			<div>
				<Upload
					name="upload_file"
          multiple={multiple}
					action={action}
					headers={{ 'X-Requested-With': null, 'Access-Control-Request-Headers': null }}
					listType="picture-card"
					fileList={fileList}
					onPreview={this.handlePreview}
					onRemove={this.onRemove}
					beforeUpload={this.beforeUpload}
					accept={accept}
					onChange={this.onChange}
					locale={{ uploading: '上传中...' }}
					{...rest}
				>
					{props.disabled && props.disabled === true ? null : (limitCount && fileList.length >= limitCount) ? null : uploadButton}
				</Upload>
				<ImageViewer visible={previewVisible} urls={[previewImage]} onClose={this.handleCancel} />

				<Modal
					title='编辑图片'
					keyboard={false}
					maskClosable={false}
					visible={cutVisible}
					onOk={this.confirmCutImg}
					onCancel={this.cancelCut}
					width={props.cut ? 700 : 500}
					wrapClassName='eh-image-upload-cut-modal'
					confirmLoading={spinning}
				>
					<Spin spinning={spinning}>
						<div className='cut-box'><img src='' id='cut-image' ref={c => this.cutImage = c} /></div>
						<div className='cut-btns'>
							<Button onClick={() => cropper.rotate(-90)}><RollbackOutlined className='icon' />左转90度</Button>
							<Button onClick={() => cropper.rotate(90)}><RollbackOutlined className='icon turn-right' />右转90度</Button>
							<Button onClick={() => cropper.zoom(0.1)}><PlusCircleOutlined className='icon' />放大</Button>
							<Button onClick={() => cropper.zoom(-0.1)}><MinusCircleOutlined className='icon' />缩小</Button>
							<Button onClick={() => cropper.reset()}><RetweetOutlined className='icon' />重置</Button>
						</div>
					</Spin>
				</Modal>
			</div>
		);
	}
}

UploadImage.propTypes = {
	// 图片上传路径
	action: PropTypes.string,
	// 图片上传所支持格式,传入文件类型的MIME，多个类型以 ‘,’分隔开
	accept: PropTypes.string,
	// 上传按钮所显示的文字
	uploadText: PropTypes.string,
	// 剪切图片填充的颜色
	fillColor: PropTypes.string,
	// 已上传的图片
	fileList: PropTypes.arrayOf(PropTypes.shape({
		uid: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number,
		]),
		name: PropTypes.string,
		url: PropTypes.string,
		thumbUrl: PropTypes.string,
		size: PropTypes.number
	})),
	// 图片上传限制张数
	limitCount: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	// 图片上传限制大小 M K
	limitPerSize: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	cut: PropTypes.bool,							// 图片是否需要裁剪
	aspectRatio: PropTypes.number,    // 图片裁剪比例
	// 组件回调函数:
	onChange: PropTypes.func,
	// 自定义提示文案
	locale: PropTypes.object,
};

UploadImage.defaultProps = {
	fillColor: 'transparent',
	accept: 'image/png,image/jpeg,image/gif,image/svg+xml',
	uploadText: '上传',
	cut: false,
	aspectRatio: 16 / 9,
	locale: {
		limitPerSizeTips: '请上传不超过${sizeText}的图片',
		acceptTips: '仅支持JPG/JPEG/PNG/SVG格式的图片',
	}
};

export default UploadImage;
